import { render, staticRenderFns } from "./ImagePreviewModal.vue?vue&type=template&id=308b6e04&scoped=true"
import script from "./ImagePreviewModal.vue?vue&type=script&lang=js"
export * from "./ImagePreviewModal.vue?vue&type=script&lang=js"
import style0 from "./ImagePreviewModal.vue?vue&type=style&index=0&id=308b6e04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308b6e04",
  null
  
)

export default component.exports